export default {
	categories: {
		report: {
			'antibody_barcoding': "Code à barres des anticorps",
			'antisaccade_task': "Tâche antisaccade",
			'body_fluid': "Fluide corporel",
			'canards_sign': "Signe des Canards",
			'cit_program_tumor_identity_cards': "CTI Cartes d'identité des tumeurs",
			'companion_diagnostic': "Diagnostic compagnon",
			'coordinated_diagnostics': "Diagnostic coordonné",
			'cosmed': "COSMED",
			'cryoglobulinemia': "Cryoglobulinémie",
			'diagnostic_overshadowing': "L'ombrage diagnostique",
			'differential_diagnosis': "Diagnostic différentiel",
			'directhit': "Coup direct",
			'dot_cancellation_test': "Test d'annulation de point",
			'drehmann_sign': "Signe Drehmann",
			'elbow_extension_test': "Test d'extension du coude",
			'electrophysiological_techniques_for_clinical_diagnosis': "Techniques électrophysiologiques de diagnostic clinique",
			'external_cause': "Cause externe",
			'fast_(stroke)': "AVC",
			'fine-needle_aspiration': "Aspiration à l'aiguille fine",
			'flow-mediated_dilation': "Dilatation par écoulement",
			'frax': "FRAX",
			'gender-bias_in_medical_diagnosis': "Préjugés sexistes dans le diagnostic médical",
			'immunolabeling': "Immunomarquage",
			'instantaneous_wave-free_ratio': "Rapport instantané sans ondes",
			'laboratory_diagnosis_of_viral_infections': "Diagnostic en laboratoire des infections virales",
			'martha_mitchell_effect': "Effet Martha Mitchell",
			'medical_findings': "Constatations médicales",
			'medical_laboratory': "Laboratoire médical",
			'mental_status_examination': "Examen de l'état mental",
			'microvesicles': "Microvésicules",
			'nasoendoscopy': "Nasoendoscopie",
			'nekrep_case': "Affaire Nekrep",
			'nucleic_acid_test': "Test d'acide nucléique",
			'oswestry_disability_index': "Indice d'incapacité d'Oswestry",
			'overdiagnosis': "Surdiagnostic",
			'paternity': "Paternité",
			'pericardiocentesis': "Péricardiocentèse",
			'photoacoustic_effect': "Effet photoacoustique",
			'prati_criteria': "Critères Prati",
			'pseudothrombocytopenia': "Pseudothrombocytopénie",
			'psychiatric_assessment': "Bilan psychiatrique",
			'psychiatric_interview': "Entretien psychiatrique",
			'qns': "QNS",
			'radiopharmaceutical': "Radiopharmaceutique",
			'rectal_discharge': "Décharge rectale",
			'schooliosis': "Scoliose",
			'surgical_sieve': "Tamis chirurgical",
			'sutton´s_law': "La loi de Sutton",
		},
		relations: {
			'other': "Autre",
			'doctor': "Docteur",
			'father': "Père",
			'mother': "Mère",
			'son': "Fils",
			'daughter': "Fille",
		},
		diseases: {
			'alergias': "Allergies",
			'alzheimer´s_disease': "La maladie d'Alzheimer",
			'amyotrophic_lateral_sclerosis_(als)': "Sclérose latérale amyotrophique (SLA)",
			'aneurisma': "Anévrisme",
			'ansiedade': "L'anxiété",
			'arrhythmia_of_the_heart': "Arythmie cardiaque",
			'arthritis': "Arthrite",
			'asma': "L'asthme",
			'atrial_fibrillation': "Fibrillation auriculaire",
			'autism': "Autisme",
			'avc': "AVC",
			'bedsores_(pressure_ulcers)': "Escarres",
			'bipolar_disorder_(manic-depressive_illness)': "Trouble bipolaire (maladie maniaco-dépressive)",
			'bócio': "Goitre",
			'cancer': "Cancer",
			'cataracts': "Cataractes",
			'cholesterol': "Cholestérol",
			'chronic_kidney_failure': "Insuffisance rénale chronique",
			'coagulação_na_sangue': "Coagulation du sang",
			'copd,_or_chronic_obstructive_pulmonary_disease': "MPOC ou maladie pulmonaire obstructive chronique",
			'depressão': "Dépression",
			'diabetes': "Diabète",
			'diminuição_auditiva': "Déficience auditive",
			'esquizofrenia': "Schizophrénie",
			'fibrilhação_auricular': "Fibrillation auriculaire",
			'fibromyalgia': "Fibromyalgie",
			'glaucoma': "Glaucome",
			'heart_disease': "Maladie cardiaque",
			'hepatitis': "Hépatite",
			'hiv/aids': "VIH / SIDA",
			'hypertension_(high_blood_pressure)': "Hypertension (pression artérielle élevée)",
			'hyperthyroidism_(overactive_thyroid)': "Hyperthyroïdie (thyroïde hyperactive)",
			'hypothyroidism_(underactive_thyroid)': "Hypothyroïdie (thyroïde sous-active)",
			'incontinence,_urinary': "Incontinence urinaire",
			'inflammatory_bowel_disease_(ibd)': "Maladie inflammatoire de l'intestin (MII)",
			'irritable_bowel_syndrome_(ibs)': "Syndrome du côlon irritable (IBS)",
			'kidney_failure,_chronic': "Insuffisance rénale chronique",
			'leukemia': "Leucémie",
			'liver_failure,_acute': "Insuffisance hépatique aiguë",
			'liver_spots_(age_spots)': "Taches de foie (taches de vieillesse)",
			'lupus': "Lupus",
			'lymphoma,_hodgkin´s_(hodgkin´s_disease)': "Lymphome de Hodgkin (maladie de Hodgkin)",
			'lymphoma,_non-hodgkin´s': "Lymphome non hodgkinien",
			'macular_degeneration,_dry': "Dégénérescence maculaire sèche",
			'mastectomia': "Mastectomie",
			'melanoma,_skin_cancer': "Mélanome, cancer de la peau",
			'multiple_sclerosis_(ms)': "Sclérose en plaques (SEP)",
			'obstructive_sleep_apnea': "Apnée obstructive du sommeil",
			'osteoarthritis': "Arthrose",
			'osteoporosis': "L'ostéoporose",
			'pancreatic_cancer': "Cancer du pancréas",
			'parkinson´s_disease': "La maladie de Parkinson",
			'periodontitis': "Parodontite",
			'pneumonia': "Pneumonie",
			'post-traumatic_stress_disorder_(ptsd)': "Trouble de stress post-traumatique (SSPT)",
			'psoriasis': "Psoriasis",
			'rheumatoid_arthritis': "La polyarthrite rhumatoïde",
			'rinite': "Rinite",
			'staph_infections': "Infections au staphylocoque",
			'stroke': "Stroke",
			'thrush,_oral': "Grive orale",
			'transient_ischemic_attack_(tia)': "Attaque ischémique transitoire (AIT)",
			'tuberculosis_(tb)': "Tuberculose (TB)",
			'ulcerative_colitis': "Colite ulcéreuse",
			'vascular_dementia': "La démence vasculaire",
			'vertigo': "Vertiges",
			'wrinkles': "Les rides",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/categories/categories_fr.js